import type { TFunction } from 'i18next';

export interface BillingCycleLabelInput {
  cycleName?: string | null;
  interval?: string | null;
}

export function resolveBillingCycleLabel(input: BillingCycleLabelInput, t: TFunction): string | null {
  const raw = (input.cycleName ?? input.interval ?? '').trim();
  if (!raw) return null;

  const normalized = raw.toLowerCase();

  // Common backend names.
  if (normalized === 'monthly billing' || normalized === 'monthly') {
    return t('checkout.billingCycles.monthly', 'Monthly');
  }
  if (normalized === 'yearly billing' || normalized === 'yearly' || normalized === 'annual') {
    return t('checkout.billingCycles.yearly', 'Yearly');
  }

  // Heuristic fallback for custom names that still contain a recognizable interval.
  if (normalized.includes('month')) {
    return t('checkout.billingCycles.monthly', 'Monthly');
  }
  if (normalized.includes('year') || normalized.includes('annual')) {
    return t('checkout.billingCycles.yearly', 'Yearly');
  }

  return raw;
}

